<div class="container">
  <!-- Toast Notification -->
  <app-agricola-toast
    [message]="toastMessage"
    [type]="toastType"
    [show]="showToast"
    (close)="hideToast()">
  </app-agricola-toast>

  <div class="card">
    <app-agricola-stepper
      [steps]="steps"
      [currentStep]="selectedIndex"
      (backClick)="goBack()"
      (stepClick)="goToStep($event)">
    </app-agricola-stepper>
    <!-- Título -->
    <div class="card">
      <h2 class="title-center">Ingresa los beneficiarios</h2>
    </div>

    <div class="info-banner" role="alert" *ngIf="showErrorBanner">
      <div class="info-banner-icon">
        <img src="assets/agricola/toast-warning.svg" alt="" aria-hidden="true">
      </div>
      <div class="info-banner-text">
        <span>{{ errorMessage || 'Revisa la información de beneficiarios para continuar.' }}</span>
      </div>
    </div>

    <div class="info-banner" role="status" *ngIf="showSuccessBanner">
      <div class="info-banner-icon">
        <img src="assets/agricola/toast-idea.svg" alt="" aria-hidden="true">
      </div>
      <div class="info-banner-text">
        <span>{{ successMessage }}</span>
        <button type="button" class="banner-close" aria-label="Cerrar mensaje" (click)="closeSuccessBanner()">×</button>
      </div>
    </div>

    <div class="insured-block">
      <!-- Contenido principal -->
      <div class="card main-card">

        <div class="left-info">
          <p>
            <span class="label">Creación de producto:</span><br>
            Tipo de producto: Póliza plan vida segura
          </p>
        </div>
      </div>

      <!-- Header con párrafo y porcentaje total -->
      <div class="card main-card">
        <div class="benef-header-row">
          <p class="benef-info">
            <span class="label">Beneficiarios de la póliza</span><br>
            Puedes continuar sin beneficiarios. Si agregas uno o más, el total de participación debe ser igual a 100%.
          </p>
          <div class="right-info">
            <div class="progress-header">
              <span>{{ totalParticipation }}%</span>
            </div>
            <div class="progress-bar">
              <div class="progress-fill" [style.width.%]="totalParticipation"></div>
            </div>
            <div class="progress-label">Total de participación</div>
          </div>
        </div>
      </div>

      <!-- Lista de beneficiarios -->
      <div class="card" *ngIf="beneficiaries.length > 0">
        <div class="benef-list">
          <div class="benef-item" *ngFor="let b of beneficiaries.controls; let i = index">
            <div class="benef-content">
              <div class="benef-left">
                <div class="avatar">
                  <img src="assets/agricola/header-user.svg" alt="" aria-hidden="true">
                </div>
                <div class="benef-text">
                  <div class="benef-name">{{ b.get('name')?.value }}</div>
                  <div class="benef-meta">
                    {{ getRelationshipLabel(b.get('relationship')?.value) }} · ID {{ b.get('identification_id')?.value }}
                  </div>
                </div>
              </div>

              <div class="benef-center">
                {{ b.get('percentage')?.value }}%
              </div>

              <div class="benef-actions">
                <button type="button" class="link" (click)="onDeleteBeneficiary(i)">Eliminar</button>
                <button type="button" class="link" (click)="onEditBeneficiary(i)">Editar</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Botón añadir beneficiarios -->
      <div class="card">
        <button type="button"
                class="link-add"
                [disabled]="loadingRelationships || beneficiaries.length >= 5"
                (click)="onAddBeneficiary()">
          <img src="assets/agricola/beneficiarios.svg" alt="Añadir beneficiarios" class="icon-users" />
          {{ loadingRelationships ? 'Cargando parentescos...' : 'Añadir beneficiario' }}
        </button>
      </div>
    </div>

    <!-- buttons -->
    <div class="actions">
      <app-sis-button variant="secondary" (pressed)="goBack()">Cancelar</app-sis-button>
      <app-sis-button (pressed)="onContinueClick()">Continuar</app-sis-button>
    </div>
  </div>

</div>
